import { Button, Typography } from '@scale/scaleui';
import React from 'react';
import { useFlushRedis } from 'react-scale/components/ExpertManagement/hooks/mutations/useFlushRedis';

const renderTool = ({
  title,
  description,
  render,
}: {
  title: string;
  description: string;
  render: JSX.Element;
}) => {
  return (
    <div className={'flex flex-col gap-2'}>
      <Typography.H4>{title}</Typography.H4>
      <Typography.Paragraph3>{description}</Typography.Paragraph3>
      <div>{render}</div>
    </div>
  );
};

export const System: React.FC = () => {
  const { mutate, isLoading } = useFlushRedis();

  return (
    <div className="flex flex-col gap-4">
      {renderTool({
        title: 'Flush Redis',
        description:
          'Flush the redis cache to remove ALL redis keys for expert-management.  May result in slow load times while cache repopulates.',
        render: (
          <Button size="lg" variant="secondary" onClick={() => mutate()} disabled={isLoading}>
            Flush Redis
          </Button>
        ),
      })}
    </div>
  );
};
